import { Chip } from '@mui/material'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { API_URI } from '../../constants/GlobalConstants'
import { useSelector } from 'react-redux'
import fileDownload from 'js-file-download'

const Detail = ({ p, settings }) => {
    const userLogin = useSelector(state => state.userSignIn)
    const { userInfo } = userLogin

    const handleExportPDF = async () => {
        try {
            const response = await axios.get(
                `${API_URI}/api/appointment/get-appoint-pdf/${p._id}`,
                {
                    headers: { Authorization: `Bearer ${userInfo.token}` },
                    responseType: 'blob'
                }
            )
            // Format the appointment date for the filename (YYYY-MM-DD)
            const appointmentDate = p.timing ? new Date(p.timing).toISOString().split('T')[0] : 'unknown-date';
            fileDownload(response.data, `Appointment_${appointmentDate}.pdf`)
        } catch (error) {
            console.error("Error exporting PDF:", error)
            alert("Failed to export PDF. Please try again.")
        }
    }

    // Format date and time for display
    const formatDateTime = (dateString) => {
        const options = { 
            year: 'numeric', 
            month: '2-digit', 
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };
        return new Date(dateString).toLocaleString(undefined, options);
    };

    // Render action history items
    const renderActionHistory = () => {
        if (!p.actionHistory || p.actionHistory.length === 0) {
            return <p>No action history available.</p>;
        }

        return p.actionHistory.map((historyItem, index) => {
            let message = '';
            if (historyItem.type === 'created') {
                message = `The action has been added with ${historyItem.action} on ${formatDateTime(historyItem.timestamp)}`;
            } else if (historyItem.type === 'updated') {
                message = `The action has been updated from ${historyItem.previousAction} to ${historyItem.action} on ${formatDateTime(historyItem.timestamp)}`;
            }
            
            return (
                <li key={index} className="list-group-item">
                    {message}
                </li>
            );
        });
    };

    return (
        <>
            <main className="page-content">
                {/*breadcrumb*/}
                <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                    <div className="breadcrumb-title pe-3">Appointment</div>
                    <div className="ps-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 p-0">
                                <li className="breadcrumb-item">
                                    <Link to="/appointments">
                                        <i className="bx bx-calendar-event" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Detail
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                {/*end breadcrumb*/}
                <div className="card border shadow-none">
                    <div className="card-header py-3">
                        <div className="row align-items-center g-3">
                            <div className="col-12 col-lg-6">
                                <h5 className="mb-0">{p.name}</h5>
                            </div>
                            <div className="col-12 col-lg-6 text-md-end">
                                <Link to={`/edit-appointment/${p._id}`} className="btn btn-sm btn-secondary me-2">
                                    <i className="fadeIn animated bx bx-edit-alt" /> Edit
                                </Link>
                                <Link to="#" onClick={handleExportPDF} className="btn btn-sm btn-danger me-2">
                                    <i className="bi bi-file-earmark-pdf-fill" /> Export as PDF
                                </Link>
                                <Link to=""
                                    onClick={() => window.print()}
                                    className="btn btn-sm btn-secondary"
                                >
                                    <i className="bi bi-printer-fill" /> Print
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="card-header py-2 bg-light">
                        <div className="row row-cols-1 row-cols-lg-3">
                            <div className="col">
                                <div className="">
                                    <address className="m-t-5 m-b-5">
                                        <strong className="text-inverse">Address:</strong>
                                        <br />
                                        {p.address || `${settings.street}, ${settings.city}, ${settings.province}, ${settings.postalCode}, ${settings.country}`}
                                    </address>
                                </div>
                            </div>
                            <div className="col">
                                <div className="">
                                    <address className="m-t-5 m-b-5">
                                        <strong className="text-inverse">Contact Info</strong>
                                        <br />
                                        {p.phone || settings.phone}
                                        <br />
                                        {p.email || settings.email}
                                    </address>
                                </div>
                            </div>
                            <div className="col">
                                <div className="">
                                    <div className="">
                                        <b>Payment</b>
                                    </div>
                                    <div className="invoice-detail">
                                        {'$' + (p.payment || '0.00')}
                                        <br />
                                        <Chip
                                            label={p.paymentStatus ? 'Paid' : 'Pending'}
                                            color={p.paymentStatus ? 'success' : 'error'}
                                            size="small"
                                            sx={{ mt: 1 }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <span>Action <span className="badge rounded-pill bg-secondary">{p.action}</span></span> 
                        <span>Action Status {p.actionStatus ? (<span className="badge rounded-pill bg-success">Completed</span>)
                            : (<span className="badge rounded-pill bg-danger">Pending</span>)}
                        </span>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <textarea className="form-control" id="textAreaExample2" rows="14" disabled>{p.des}</textarea>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-invoice">
                                <thead>
                                    <tr>
                                        <th>OFFICIAL INVOICE</th>
                                        <th className="text-center" width="10%">
                                            PRICE
                                        </th>
                                        <th className="text-center" width="10%">
                                            TAX
                                        </th>
                                        <th className="text-right" width="20%">
                                            LINE TOTAL
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span className="text-inverse">
                                                {settings.companyName || "DBS Blinds"}
                                            </span>
                                            <br />
                                        </td>
                                        <td className="text-center">{p.payment || '0.00'}</td>
                                        <td className="text-center">Included</td>
                                        <td className="text-right">{p.payment || '0.00'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="row bg-light align-items-center m-0">
                            <div className="col col-auto p-4">
                                <p className="mb-0">SUBTOTAL</p>
                                <h4 className="mb-0">{p.payment || '0.00'}</h4>
                            </div>
                            <div className="col col-auto p-4">
                                <i className="bi bi-plus-lg text-muted" />
                            </div>
                            <div className="col col-auto me-auto p-4">
                                <p className="mb-0">GATEWAY FEE (0%)</p>
                                <h4 className="mb-0">$0.00</h4>
                            </div>
                            <div className="col bg-dark col-auto p-4">
                                <p className="mb-0 text-white">TOTAL</p>
                                <h4 className="mb-0 text-white">{p.payment || '0.00'}</h4>
                            </div>
                        </div>
                        {/*end row*/}
                        <hr />
                        {/* begin invoice-note */}
                        <div className="my-3">
                            * Make all cheques payable to {settings.companyName || "DBS Blinds"}
                            <br />
                            * Payment is due within 3 days
                            <br />* If you have any questions concerning this invoice, contact {settings.email || "sales@dbsblinds.com"}
                        </div>
                        {/* end invoice-note */}
                    </div>
                    {/* Action History Section */}
                    <div className="card-body border-top">
                        <h5 className="mb-3">Action History</h5>
                        <div className="bg-light p-3 rounded">
                            <ul className="list-group">
                                {renderActionHistory()}
                            </ul>
                        </div>
                    </div>
                    <div className="card-footer py-3">
                        <p className="text-center mb-2">THANK YOU FOR YOUR BUSINESS</p>
                        <p className="text-center d-flex align-items-center gap-3 justify-content-center mb-0">
                            <span className="">
                                <i className="bi bi-globe" /> {settings.webAddress || "www.dbsblinds.com"}
                            </span>
                            <span className="">
                                <i className="bi bi-telephone-fill" /> {settings.phone || "+1-855-230-5385"}
                            </span>
                            <span className="">
                                <i className="bi bi-envelope-fill" /> {settings.email || "sales@dbsblinds.com"}
                            </span>
                        </p>
                    </div>
                </div>
            </main>
        </>
    )
}

export default Detail